import { Icon, IconButton } from '@chakra-ui/react'
import { faTrashCanXmark } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { useState } from 'react'


export const RemoveButton = ({ onClick }: { onClick: () => Promise<any> }) => {
  const [loading, setLoading] = useState(false)

  return <CustomTooltip label="Odebrat" color='red.800' hasArrow>
    <IconButton
      size="sm"
      variant="ghost"
      color='red.700'
      p={1.5}
      m={-.5}
      onClick={() => {
        setLoading(true)
        onClick().finally(() => setTimeout(() => setLoading(false), 100))
      }}
      isLoading={loading} aria-label='Add' icon={<Icon as={FontAwesomeIcon} icon={faTrashCanXmark} size='lg' />}>
    </IconButton>
  </CustomTooltip>
}